import { render, staticRenderFns } from "./ProductContentAssignments.vue?vue&type=template&id=01d1466c&scoped=true"
import script from "./ProductContentAssignments.vue?vue&type=script&lang=js"
export * from "./ProductContentAssignments.vue?vue&type=script&lang=js"
import style0 from "./ProductContentAssignments.vue?vue&type=style&index=0&id=01d1466c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1466c",
  null
  
)

export default component.exports